import AuthService from '../../services/AuthService';

export const getPrivilegesTo = (privilegesCode: string) => {
  const userPrivileges = AuthService.GetInstance().privileges;

  return userPrivileges.indexOf(privilegesCode) !== -1;
}


// WEBPACK FOOTER //
// ./src/helpers/Users/getPrivilegesTo.ts